import { useMemo } from 'react';
import { skipToken } from '@reduxjs/toolkit/query';
import { useGetServiceWithOperatorsQuery } from '../services';
import { SelectInputOption } from '@/components/inputs/SelectInput';

interface UseLogisticOperatorServicesOptionsProps {
  shouldFetch?: boolean;
  logisticOperatorId?: string | null;
}

export const useLogisticOperatorServicesOptions = ({
  shouldFetch = false,
  logisticOperatorId,
}: UseLogisticOperatorServicesOptionsProps = {}) => {
  const id = logisticOperatorId?.trim() ?? '';
  const shouldSkip = !shouldFetch || !id;

  const { data, isLoading } = useGetServiceWithOperatorsQuery(
    shouldSkip
      ? skipToken
      : { logisticOperatorId: id, paginated: { page: 1, pageSize: 500 } }
  );

  const logisticOperatorServiceOptions: SelectInputOption[] = useMemo(() => {
    if (!data?.items?.length) return [];

    return data.items
      .map((item) => {
        const label =
          (item as { description?: string }).description ||
          item.commercialService?.commercialName ||
          item.commercialService?.name ||
          item.id;
        return { value: item.id, label };
      })
      .sort((a, b) =>
        a.label.localeCompare(b.label, 'es', { sensitivity: 'base' })
      );
  }, [data?.items]);

  return {
    logisticOperatorServiceOptions,
    services: data?.items ?? [],
    isLoading,
    requiresLogisticOperator: shouldFetch && !id,
  };
};
